import observerPolyfill from 'intersection-observer';
import { CountUp } from 'countup.js';
import _ from 'lodash'

/**
 * Setup home page scroller
 * @param {nodeItem} activeSlide
 */
function scrollLockAnimation(activeSlide) {
	let titleWrap = document.querySelectorAll('.scroller-title');
	let sliderTrigger = document.querySelectorAll('.scroller-gallery__trigger');

	titleWrap.forEach((group) => {
		let titleSlides = group.querySelectorAll('.scroller-title__slide');

		titleSlides.forEach((node, index) => {
			index + 1 == activeSlide
				? node.classList.add('active')
				: node.classList.remove('active')
		})
	})

	sliderTrigger.forEach((trigger) => {
		trigger.setAttribute('data-slide', activeSlide);
		trigger.dispatchEvent(new Event('click'));
	})
}

export function activeSection()
{
	const config = {
		root: null,
		rootMargin: '-12.5% 0px',
		threshold: 0.075,
	};

	const stickyConfig = {
		root: null,
		rootMargin: '0px 0px 50% 0px',
		threshold: 1,
	};

	//let section = [].slice.call(document.querySelectorAll('[data-wp]'));
	let section = [].slice.call(document.querySelectorAll('[data-wp]'));
	let sticky = [].slice.call(document.querySelectorAll('[data-sticky]'));
	let stickyThrottle = _.throttle((entry) => {
		sectionSticky(entry);
	}, 400);

	if ('IntersectionObserver' in window)
	{
		/**
		 * setup default intersction observer
		 * @param {Obj} config
		 */
		let sectionObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					sectionActive(entry);
				}
			});
		}, config);

		let stickyObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				stickyThrottle(entry);
			});
		}, stickyConfig);

		/**
		 * @param {node} Section
		 */
		section.forEach(function(section) {
			sectionObserver.observe(section);
		});

		/**
		 * Sets up sticky nav animation
		 * @param {node} Section
		 */
		sticky.forEach(function(section) {
			stickyObserver.observe(section);
		});
	}
	else
	{
		/**
		 * Sets up polyfills
		 */
		let io = new observerPolyfill(function(entries) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					sectionActive(entry);
				}
			});
		}, config);

		let stickyIo = new observerPolyfill(function(entries) {
			entries.forEach(function (entry) {
				stickyThrottle(entry);
			});
		}, stickyConfig);

		section.forEach(function(section) {
			stickyIo.POLL_INTERVAL = 100;
			stickyIo.observe(section);
		});

		sticky.forEach(function(section) {
			stickyIo.POLL_INTERVAL = 100;
			stickyIo.observe(section);
		});
	}
}

/**
 * Setup waypoints animation
 * @param {nodeItem} entry
 */
function sectionActive(entry) {
	let activeSection = entry.target;

	if (
		activeSection.classList.contains('statistics-block')
		&& !activeSection.classList.contains('active')
	) {
		counter(activeSection)
	}

	activeSection.classList.add('active');

	if (activeSection.classList.contains('home-scroller__trigger')) {
		const activeSlide = activeSection.getAttribute('data-slide');
		scrollLockAnimation(activeSlide);
	}
}

/**
 * Setup sticky animation
 * @param {nodeItem} entry
 */
function sectionSticky(entry) {
	let activeSection = entry.target;
	activeSection.classList.toggle('active', entry.intersectionRatio < 1);
}

/**
 *
 * @param {nodeItem} activeSection
 * Count up animation
 */
function counter(activeSection) {
	let counters = activeSection.querySelectorAll('.stat-number');

	counters.forEach((counter) => {
		let value = counter.getAttribute('data-stat');
		let timing = value <= 10 ? 1 : 3;

		let counterAnimation = new CountUp(counter, value, {
			duration: timing,
		});

		counterAnimation.start();
	})
}




// WEBPACK FOOTER //
// ./scripts/modules/waypoints.js